export default "/images/odno.svg?0ef2439ea0c7878b1e11ef9d5af0d89a";